import TokenBalanceChart from './TokenBalanceChart'
import connect from './connect'

export default connect(TokenBalanceChart)


// WEBPACK FOOTER //
// ./src/components/TokenBalanceChart/index.js